const MISSION_ROLE_STATES = {
  draft: "DRAFT",
  published: "PUBLISHED",
  unpublished: "UNPUBLISHED",
  unpublishedNew: "UNPUBLISHED_NEW",
  draftInProgress: "DRAFT_IN_PROGRESS",
  closed: "CLOSED",
};

const isDraftInProgress = (state) => state === MISSION_ROLE_STATES.draftInProgress;

export { isDraftInProgress };

export default MISSION_ROLE_STATES;
